import { createAction, props } from '@ngrx/store';


export const getCustomTheme = createAction(
  '[Event Page] Get Custom Theme',
  props<any>()
);

export const getCustomThemeSuccess = createAction(
  '[Event Page] Get Custom Theme Success',
  props<any>()
);

export const getCustomThemeFailure = createAction(
  '[Event Page] Get Custom Theme Failure',
  props<any>()
);


export const getCustomThemes = createAction(
  '[Event Page] Get Custom Themes',
  props<any>()
);

export const getCustomThemesSuccess = createAction(
  '[Event Page] Get Custom Themes Success',
  props<any>()
);

export const getCustomThemesFailure = createAction(
  '[Event Page] Get Custom Themes Failure',
  props<any>()
);

export const createCustomTheme = createAction(
  '[Event Page] Create Custom Theme',
  props<any>()
);

export const createCustomThemeSuccess = createAction(
  '[Event Page] Create Custom Theme Success',
  props<any>()
);

export const createCustomThemeFailure = createAction(
  '[Event Page] Create Custom Theme Failure',
  props<any>()
);

export const deleteCustomTheme = createAction(
  '[Event Page] Delete Custom Theme',
  props<any>()
);

export const deleteCustomThemeSuccess = createAction(
  '[Event Page] Delete Custom Theme Success',
  props<any>()
);

export const deleteCustomThemeFailure = createAction(
  '[Event Page] Delete Custom Theme Failure',
  props<any>()
);

export const updateCustomTheme = createAction(
  '[Event Page] Update Custom Theme',
  props<any>()
);

export const updateCustomThemeSuccess = createAction(
  '[Event Page] Update Custom Theme Success',
  props<{ data: any }>()
);

export const updateCustomThemeFailure = createAction(
  '[Event Page] Update Custom Theme Failure',
  props<{ error: any }>()
);
